// Blog Posts Filter Component Scripts using Alpine.js

import { Alpine } from '@webikon/webentor-core/_alpine';

interface BlogPostsFilterData {
  isExpanded: boolean;
  showDesktopFilter: boolean;
  isMobile: boolean;
  categoryFieldSelector: string;
  orderByFieldSelector: string;
  showText: string;
  hideText: string;
  $el?: HTMLElement;
  init(): void;
  toggleFilters(): void;
  removeFilterCategory(categorySlug: string): void;
  handleCategoryChange(categorySlug: string, isChecked: boolean): void;
  toggleButtonText: string;
  shouldShowFilter: boolean;
}

export default function blogPostsFilter(): BlogPostsFilterData {
  return {
    isExpanded: false,
    showDesktopFilter: false,
    isMobile: window.innerWidth < 768,
    categoryFieldSelector: '',
    orderByFieldSelector: '',
    showText: '',
    hideText: '',

    init() {
      // Get text strings from data attributes
      const container = this.$el as HTMLElement;
      this.showText = container.dataset.showText || '';
      this.hideText = container.dataset.hideText || '';
      this.categoryFieldSelector = container.dataset.fieldSelector || '';
      this.orderByFieldSelector = container.dataset.orderByField || '';

      // Watch for mobile state changes
      this.$watch('isMobile', () => {
        if (!this.isMobile) {
          this.showDesktopFilter = false;
        }
      });

      // Add resize listener for responsive behavior
      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 768;
      });
    },

    toggleFilters() {
      this.isExpanded = !this.isExpanded;
    },

    handleCategoryChange(categorySlug: string, isChecked: boolean) {
      try {
        const url = new URL(window.location.href);

        // Get current categories
        const currentCategories = url.searchParams.getAll(
          `${this.categoryFieldSelector}[]`,
        );

        // Remove all existing category parameters
        url.searchParams.delete(`${this.categoryFieldSelector}[]`);

        // Handle special "all" category case
        if (categorySlug !== 'all') {
          // Handle regular category selection
          let updatedCategories = [...currentCategories];

          // Remove "all" from current categories if it exists (since we're selecting a specific category)
          updatedCategories = updatedCategories.filter((cat) => cat !== 'all');

          if (isChecked) {
            // Add category if not already present
            if (!updatedCategories.includes(categorySlug)) {
              updatedCategories.push(categorySlug);
            }
          } else {
            // Remove category
            updatedCategories = updatedCategories.filter(
              (cat) => cat !== categorySlug,
            );
          }

          // Add updated categories back to URL (excluding "all")
          updatedCategories.forEach((category) => {
            if (category !== 'all') {
              url.searchParams.append(
                `${this.categoryFieldSelector}[]`,
                category,
              );
            }
          });
        }

        // Reset pagination when changing filters
        url.searchParams.delete('paged');

        // Navigate to updated URL
        window.location.href = url.toString();
      } catch (error) {
        console.error('Error updating URL parameters:', error);
      }
    },

    removeFilterCategory(categorySlug: string) {
      this.handleCategoryChange(categorySlug, false);
    },

    get toggleButtonText() {
      return this.isExpanded ? this.hideText : this.showText;
    },

    get shouldShowFilter() {
      return !this.isMobile || this.showDesktopFilter;
    },
  };
}

// Register Alpine component
Alpine.data('blogPostsFilter', blogPostsFilter);
